<template>
  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
    <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200 overflow-auto" style="max-height:300px" v-if="Object.keys(files).length > 0">
      <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm" v-for="(file, key) in files" v-bind:key="key">
        <div class="items-center flex">
          <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd" />
          </svg>
          <a :href="file.original_url" class="font-medium text-indigo-600 hover:text-indigo-500">
            <span class="ml-2 truncate" :title="file.file_name">{{(file.file_name.length > 20) ? file.file_name.substring(0,20) + '...' : file.file_name}}</span>
          </a>
        </div>
        <div class="ml-4 flex-shrink-0">
            <icon name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-red-500 hover:fill-red-700 cursor-pointer" @click="remove(file.uuid)" />
        </div>
      </li>
    </ul>
    <div v-else class="italic text-sm text-gray-400">{{$t('global.not_set')}}</div>
    <button class="bg-gray-400 hover:bg-gray-500 text-white font-bold py-1 px-3 rounded mt-2"  data-modal-toggle="defaultModal" @click="showModal = !showModal">
      {{$t('global.add_files')}}
    </button>
    <FileUploadModal v-model="showModal" :model="intervention" :upload-url="uploadUrl"/>
  </dd>
</template>
<script>
import Icon from '@/Shared/Icon'
import FileUploadModal from '@/Shared/FileUploadModal'

export default {
  components:{Icon,FileUploadModal},
  data(){
    return {
      showModal: false,
    }
  },
  props: {
    files: Object,
    intervention: Object,
    uploadUrl: {
      type: String,
      required: true,
    }
  },
  methods:{
    remove(id) {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/interventions/${this.intervention.id}/remove-file/${id}`)
        }
      })
    },
  }
}
</script>
